import { t } from "i18next"

export function getBaseForm(): any {
    return {
        "structure": {
            "fields": {
                "email": {
                    "type": "email",
                    "label": t("general-email"),
                    "removeFromLayout": false,
                    "canBeRemovedFromLayout": false,
                    "attributes": {
                        "required": true
                    }
                },
                "submit_button": {
                    "type": "submit",
                    "label": "",
                    "removeFromLayout": false,
                    "canBeRemovedFromLayout": false,
                    "attributes": {
                        "value": t("general-submit"),
                        "name": "submit_button"
                    }
                }
            },
            "layout": [
                ["email"],
                ["submit_button"]
            ],
            "attributes": {
                "accept-charset": "UTF-8",
                "action": "",
                "method": "post",
                "autocomplete": "on",
                "enctype": "multipart/form-data",
                "novalidate": false,
                "target": "_self"
            },
            //"title": "Event Registration",
            //"description": "A BEE test form"
        }
    }
}